module.exports = __webpack_public_path__ + "img/party-popper@3x.0b87fc2.png";